// this file is automatically generated by git.version.ts script
export const versions = {commit: '15857efce', tag: '2026.7.001-RELEASE'};
